import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Icon, Card, Popconfirm, Popover } from 'antd';

export class GeoCardDetail extends Component {
    static displayName = GeoCardDetail.name;

    constructor(props) {
        super(props);

        this.state = {
            geo: this.props.geo
        };

        this.deleteHr = this.deleteHr.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.geo !== prevProps.geo) {
            this.setState({ geo: this.props.geo });
        }
    }

    deleteHr() {
        this.props.delete();
    }

    render() {

        let regionNa = this.state.geo.province.region.name == "§N.A.§" ? "N/A" : this.state.geo.province.region.name
        let provinceNa = this.state.geo.province.name == "§N.A.§" ? "N/A" : this.state.geo.province.name

        return (
            <Card actions={[<Link to={"/places/edit?id=" + this.state.geo.cityId} ><Popover content='Edit'><Icon type="edit" /></Popover></Link>, <Popconfirm title="Are you sure you want to delete this city?" okText="Yes" cancelText="No" onConfirm={this.deleteHr} ><Popover content='Delete'><Icon type="close" className="blueIcon" /></Popover></Popconfirm>]}>
                <div className="fakeImageHr">{this.state.geo.province.initials}</div>
                <h3 style={{ marginBottom: '0px' }}>{this.state.geo.name}</h3>

                <hr style={{ borderColor: "#000", marginTop: '20px' }} />

                <Container fluid={true}>
                    <Row className="cardDetailData">
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Nazione:</b> {this.state.geo.province.region.nation.name}</p>
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Regione:</b> {regionNa}</p>
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Provincia:</b> {provinceNa}</p>                        
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>CAP:</b> {this.state.geo.brCityZipCodes.map((br, i) => {
                            if (i + 1 < this.state.geo.brCityZipCodes.length) {
                                    return <span key={br.zipCodeId}>{br.zipCode.value}, </span>
                                } else {
                                    return <span key={br.zipCodeId}>{br.zipCode.value}</span>
                            }
                        })
                        }
                        </p>
                    </Row>
                </Container>
            </Card >
        )
    }
}


// WEBPACK FOOTER //
// ./src/GeoRegion/GeoCardDetail.js